import { render, staticRenderFns } from "./AttackPathway.vue?vue&type=template&id=4c53cc87&scoped=true&"
import script from "./AttackPathway.vue?vue&type=script&lang=js&"
export * from "./AttackPathway.vue?vue&type=script&lang=js&"
import style0 from "./AttackPathway.vue?vue&type=style&index=0&id=4c53cc87&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c53cc87",
  null
  
)

export default component.exports